module.exports = __webpack_public_path__ + "img/a4.2a85206a.png";